// This manifest.json file is created by scripts/translate.js
// and used to populate the i18nHash map, which is required for
// the @c42/i18n Text service.

import data from '../../lang/manifest.json';

window.i18nHash = data;
